export default __webpack_public_path__ + "images/referenzen/socialmedia/beetle_and_animals_minihorse.mp4";